import {
  Button,
  Checkbox,
  FormControlLabel,
  Select,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ReactComponent as SearchIcon } from '../../../assets/images/Search.svg';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useHook as InventoryUseHook } from './useHook';
import { ExpandMore } from '@mui/icons-material';

interface FilterDrawer {
  fliterCloseDrawer: () => void;
  filterSubmit: (data: any) => void;
  filterDrawerData?: any;
}
const FilterDrawer: React.FC<FilterDrawer> = ({
  fliterCloseDrawer,
  filterSubmit,
  filterDrawerData,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      fromSerialnumber: filterDrawerData?.serialNumberFrom || '',
      toSerialnumber: filterDrawerData?.serialNumberTo || '',
    },
  });
  const { inventoryFilterList } = useSelector((state: any) => state.inventory);
  const { fetchGetInventoryFilter } = InventoryUseHook();
  const [equipmentFilter, setEquipmentFilter] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState([]);
  const [subCategoryFilter, setSubCategoryFilter] = useState([]);
  const [gatwayNoFilter, setGatwayNoFilter] = useState([]);
  const [equipmentData, setEquipment] = React.useState<string[]>([]);
  const [categoryData, setCategoryData] = React.useState<string[]>([]);
  const [subCategoryData, setSubCategoryData] = React.useState<string[]>([]);
  const [gatewayNo, setGatewayNo] = React.useState<string[]>([]);
  const [isFilterActive, setFilterActive] = useState(false);
  const fromSerialnumber = watch('fromSerialnumber', '');
  const toSerialnumber = watch('toSerialnumber', '');

  //setSelectionFilter
  useEffect(() => {
    if (filterDrawerData) {
      setEquipment(filterDrawerData?.equipmentModel);
      setCategoryData(filterDrawerData?.category);
      setSubCategoryData(filterDrawerData?.subCategory);
      setGatewayNo(filterDrawerData?.gatewayNo);
    }
  }, [filterDrawerData]);

  //getFilter
  const getFilterData = async () => {
    await fetchGetInventoryFilter();
  };
  useEffect(() => {
    getFilterData();
  }, []);

  useEffect(() => {
    if (inventoryFilterList) {
      setEquipmentFilter(inventoryFilterList?.equipment);
      setCategoryFilter(inventoryFilterList?.category);
      setSubCategoryFilter(inventoryFilterList?.subCategory);
      setGatwayNoFilter(inventoryFilterList?.gatewayNo);
    }
  }, [inventoryFilterList]);

  //search filter
  const handleSearch = (
    data: any,
    searchValue: string,
    setFilterData: {
      (value: React.SetStateAction<never[]>): void;
      (arg0: any): void;
    },
  ) => {
    const query = searchValue.toLowerCase();
    const filtered = data?.filter((item: string) =>
      item?.toLowerCase().includes(query),
    );
    setFilterData(filtered);
  };

  //selectfilterdata
  const handleFilterSelection = (
    selectName: string | undefined,
    setFilterData: {
      (value: React.SetStateAction<string[]>): void;
      (arg0: (prevselected: any) => any): void;
    },
  ) => {
    if (!selectName) return;
    setFilterData((prevselected) => {
      if (prevselected.includes(selectName)) {
        const updatedData = prevselected.filter(
          (names) => names !== selectName,
        );
        return updatedData;
      } else {
        const updatedData = [...prevselected, selectName];
        return updatedData;
      }
    });
  };

  //activebutton
  useEffect(() => {
    const isFilterActive =
      equipmentData?.length > 0 ||
      categoryData?.length > 0 ||
      subCategoryData?.length > 0 ||
      gatewayNo?.length > 0 ||
      fromSerialnumber?.length > 0 ||
      toSerialnumber?.length > 0;

    setFilterActive(isFilterActive);
  }, [
    equipmentData,
    categoryData,
    subCategoryData,
    gatewayNo,
    fromSerialnumber,
    toSerialnumber,
  ]);

  //submitfilterdata
  const submitedData = (data: any) => {
    const payload = {
      serialNumberFrom: data.fromSerialnumber,
      serialNumberTo: data.toSerialnumber,
      equipmentModel: equipmentData,
      category: categoryData,
      subCategory: subCategoryData,
      gatewayNo: gatewayNo,
    };
    filterSubmit(payload);
    fliterCloseDrawer();
  };

  return (
    <form
      onSubmit={handleSubmit(submitedData)}
      className="fliter-drawer-container"
    >
      <div>
        <div className="fliter-drawer-header">
          <p className="fliter-drawer-header-content">Fliters</p>
          <p className="fliter-drawer-header-text">Restore</p>
        </div>

        <div className="fliter-drawer-body">
          <div className="fliter-drawer-body-content">
            <section className="fliter-drawer-serial-no">
              <div>
                <p className="fliter-drawer-body-lable">From Serial No</p>
                <TextField
                  variant="outlined"
                  placeholder="From Serial No"
                  fullWidth
                  type="number"
                  {...register('fromSerialnumber')}
                />
              </div>
              <div>
                <p className="fliter-drawer-body-lable">To Serial No</p>
                <TextField
                  variant="outlined"
                  placeholder="To Serial No"
                  fullWidth
                  type="number"
                  {...register('toSerialnumber')}
                />
              </div>
            </section>
          </div>
          {/* <div className="fliter-drawer-body-content">
            <section className="fliter-drawer-serial-no">
              <div>
                <p className="fliter-drawer-body-lable">From GateWay No</p>
                <TextField
                  variant="outlined"
                  placeholder="From GateWay No"
                  fullWidth
                  type='number'
                  {...register('fromGateWaynumber')}
                  // onChange={handleEquipmentSearch}
                />
              </div>
              <div>
                <p className="fliter-drawer-body-lable">To GateWay No</p>
                <TextField
                  variant="outlined"
                  placeholder="To GateWay No"
                  fullWidth
                  type='number'
                  {...register('toGateWaynumber')}
                  // onChange={handleEquipmentSearch}
                />
              </div>
            </section>
          </div> */}
          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Equipment Type</p>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              value={equipmentData}
              onClose={() => setEquipmentFilter(inventoryFilterList?.equipment)}
              renderValue={() =>
                equipmentData?.length > 0 ? equipmentData.join(', ') : ' '
              }
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search user names here"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={(e) =>
                      handleSearch(
                        inventoryFilterList?.equipment,
                        e.target.value,
                        setEquipmentFilter,
                      )
                    }
                  />
                </div>
                <div className="selectoption_list_content">
                  {equipmentFilter?.map((equipment, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={equipmentData.includes(String(equipment))}
                            onChange={() => {
                              handleFilterSelection(
                                String(equipment),
                                setEquipment,
                              );
                            }}
                          />
                        }
                        label={equipment}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>

          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Category</p>
            <Select
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              value={categoryData}
              onClose={() => setCategoryFilter(inventoryFilterList?.category)}
              renderValue={() =>
                categoryData?.length > 0 ? categoryData.join(', ') : ' '
              }
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search user names here"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={(e) =>
                      handleSearch(
                        inventoryFilterList?.category,
                        e.target.value,
                        setCategoryFilter,
                      )
                    }
                  />
                </div>
                <div className="selectoption_list_content">
                  {categoryFilter?.map((category, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={categoryData.includes(String(category))}
                            onChange={() => {
                              handleFilterSelection(
                                String(category),
                                setCategoryData,
                              );
                            }}
                          />
                        }
                        label={category}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>
          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Subcategory</p>
            <Select
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              value={subCategoryData}
              onClose={() =>
                setSubCategoryFilter(inventoryFilterList?.subCategory)
              }
              renderValue={() =>
                subCategoryData?.length > 0 ? subCategoryData.join(', ') : ' '
              }
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search user names here"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={(e) =>
                      handleSearch(
                        inventoryFilterList?.subCategory,
                        e.target.value,
                        setSubCategoryFilter,
                      )
                    }
                  />
                </div>
                <div className="selectoption_list_content">
                  {subCategoryFilter?.map((subCategory, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={subCategoryData.includes(
                              String(subCategory),
                            )}
                            onChange={() => {
                              handleFilterSelection(
                                String(subCategory),
                                setSubCategoryData,
                              );
                            }}
                          />
                        }
                        label={subCategory}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>
          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Gateway Number</p>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              value={gatewayNo}
              onClose={() => setGatwayNoFilter(inventoryFilterList?.gatewayNo)}
              renderValue={() =>
                gatewayNo?.length > 0 ? gatewayNo.join(', ') : ' '
              }
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search user names here"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={(e) =>
                      handleSearch(
                        inventoryFilterList?.gatewayNo,
                        e.target.value,
                        setGatwayNoFilter,
                      )
                    }
                  />
                </div>
                <div className="selectoption_list_content">
                  {gatwayNoFilter?.map((data, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={gatewayNo.includes(String(data))}
                            onChange={() => {
                              handleFilterSelection(String(data), setGatewayNo);
                            }}
                          />
                        }
                        label={data}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>
        </div>
      </div>

      <div className="create_controller-nodata_drawer_button_content">
        <div className="create_controller-nodata_drawer_button">
          <Button
            variant="text"
            className="cencel_button"
            onClick={fliterCloseDrawer}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            type="submit"
            className={
              isFilterActive ? 'save_button' : 'save_button disabled_button'
            }
            disabled={!isFilterActive}
          >
            Apply
          </Button>
        </div>
      </div>
    </form>
  );
};

const MemoizedComponent = React.memo(FilterDrawer);
export default MemoizedComponent;
